import useSession from '../../session/useSession'
import SurveyLogsModule from './Module'

export default function useSurveyLog() {
  const session = useSession()

  SurveyLogsModule.config({
    url: session.urls?.log,
    params: { proxy_params: session.action?.action_proxy_params || {} }
  })
  return SurveyLogsModule
}
